import {
  BD_GET_PACKAGING_LISTING,
  BD_GET_PACKAGING_LISTING_SUCCESS,
  BD_GET_PACKAGING_LISTING_FAILED,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  bdPackaging: null,
}

const bdPackaging = (state = initialState, action) => {
  switch (action.type) {
    case BD_GET_PACKAGING_LISTING:
      state = {
        ...state,
        loading: true,
        bdPackaging: action.payload,
      }
      break
    case BD_GET_PACKAGING_LISTING_SUCCESS:
      state = { ...state, loading: false, bdPackaging: action.payload }
      break
    case BD_GET_PACKAGING_LISTING_FAILED:
      state = { ...state, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default bdPackaging
